import React from "react"
import styled, { css } from "styled-components"
import ProgressBar from "./ProgressBar"
import AddInfoLink from "../../../../account/components/AddInfoLink"
import { toLink } from "../common"
import { Heading } from "../../../../account/components/CardSubSection"
import { fontWeight, colors } from "buoy-theme"

const ProfInfoText = styled(Heading)`
  font-weight: ${fontWeight.regular};
  margin-bottom: 0;
  ${props =>
    props.percent
      ? css`
          color: ${colors.neutralLight};
        `
      : css`
          margin-right: 12px;
        `};
`

const InfoRow = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 24px;
  justify-content: space-between;
`

const InformationSection = ({ text, percent }) => (
  <React.Fragment>
    <InfoRow>
      <ProfInfoText>{text}</ProfInfoText>
      <ProfInfoText percent>{`${percent}% complete`}</ProfInfoText>
    </InfoRow>
    <ProgressBar percent={percent} />
    <AddInfoLink dashboard onClick={toLink("/profile")} underline={false}>
      {`+ Add ${text.toLowerCase()}`}
    </AddInfoLink>
  </React.Fragment>
)

export { InformationSection as default }


// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/InformationSection.js